"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportZorseUndefined = exports.reportMissingCategoryFeatureTranslation = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Raven = _interopRequireDefault(require("Raven"));

var reportMissingCategoryFeatureTranslation = function reportMissingCategoryFeatureTranslation(category, feature) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _Raven.default.captureMessage('Missing category feature translation', {
    level: 'error',
    extra: (0, _extends2.default)({}, extra, {
      category: category,
      feature: feature
    })
  });
};

exports.reportMissingCategoryFeatureTranslation = reportMissingCategoryFeatureTranslation;

var reportZorseUndefined = function reportZorseUndefined() {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _Raven.default.captureMessage('hubspot.zorse not defined', {
    level: 'warning',
    extra: extra
  });
};

exports.reportZorseUndefined = reportZorseUndefined;


//////////////////
// WEBPACK FOOTER
// ./js/utils/sentry.js
// module id = 382
// module chunks = 209 210 211 212